




import { Component, Mixins, Emit } from "vue-property-decorator";

@Component
export default class DialogTransparentComponent extends Mixins() {
  mounted() {
    window.addEventListener("keydown", this.handleKeyDowned, false);
    window.addEventListener("keyup", this.handleKeyUpped, false);
  }

  destroyed() {
    window.removeEventListener("keydown", this.handleKeyDowned, false);
    window.removeEventListener("keyup", this.handleKeyUpped, false);
  }

  private handleKeyDowned(event: KeyboardEvent): void {
    if (event.ctrlKey && (event.key === "," || event.keyCode === 188)) {
      this.transparentChanged(true);
    }
  }

  private handleKeyUpped(event: KeyboardEvent): void {
    this.transparentChanged(false);
  }

  onMouseOver(): void {
    this.transparentChanged(true);
  }

  onMouseOut(): void {
    this.transparentChanged(false);
  }

  @Emit("transparentChanged")
  transparentChanged(value: boolean): void {}
}
